import {useApp} from "hooks/StateHooks"
import React from "react"
import Trans from './Trans'

type ImagePlaceholderProps = {
  small?: boolean
}

class ImagePlaceholder extends React.Component<ImagePlaceholderProps> {
  render() {
    return (
      <div className={'flex flex-col justify-center items-center select-none overflow-hidden' + (this.props.small ? ' h-16 ' : ' h-64 ')}>
        <img src={useApp().basename + '/images/vehicle.png'} alt="taken" className='h-full'/>
        {
          !this.props.small &&
          <span className="w-full text-center font-semibold text-gray-400 -mt-6"><Trans>Derzeit ist kein Bild vorhanden</Trans></span>
        }
      </div>
    )
  }
}

export default ImagePlaceholder
